import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTemperatureLow,
  faRoad,
  faTruckMoving,
  faCubes,
  faHouseChimney,
  faPhone,
  faLeaf,
} from '@fortawesome/free-solid-svg-icons';
import './styles/TabletAndPhoneMenu.css';
import mascotLogo from '../images/jbc-mascot.png';

const services = [
  { title: 'Jordvarme', path: '/jordvarme', icon: faTemperatureLow },
  { title: 'Belægning', path: '/belægning', icon: faRoad },
  { title: 'Midlertidig Vej', path: '/midlertidig-vej', icon: faTruckMoving },
  { title: 'Fundamenter', path: '/fundamenter', icon: faCubes },
  { title: 'Tilbygning', path: '/tilbygning', icon: faHouseChimney },
  { title: 'LCA & Bæredygtighed', path: '/lca', icon: faLeaf },
];

function TabletAndPhoneMenu({ isOpen, toggleMenu }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (index) => {
    setOpenDropdown(prevState => prevState === index ? null : index);
  };

  const handleLinkClick = () => {
    toggleMenu();
    setOpenDropdown(null);
  };

  return (
    <div className={`tabletogmobil-menu ${isOpen ? 'open' : ''}`}>
      <div className="tabletogmobil-header">
        <img src={mascotLogo} alt="JBC Entreprenøren" className="logo-mascot" />
        <span className="logo-wordmark">
          <span className="logo-wordmark-main">JBC Entreprenøren ApS</span>
          <span className="logo-wordmark-sub">Anlæg &amp; Byggeri</span>
        </span>
      </div>
      <nav className="tabletogmobil-popup-nav">
        <ul>
          <li><Link to="/" onClick={handleLinkClick}>Hjem</Link></li>
          <li><Link to="/om-os" onClick={handleLinkClick}>Om os</Link></li>
          <li className={`tabletogmobil-menu-section ${openDropdown === 0 ? 'open' : ''}`}>
            <h3 onClick={() => toggleDropdown(0)}>Tjenester</h3>
            <ul className={`tabletogmobil-dropdown-menu ${openDropdown === 0 ? 'open' : ''}`}>
              {services.map((service) => (
                <li key={service.path}>
                  <Link to={service.path} onClick={handleLinkClick}>
                    <span className="tabletogmobil-icon">
                      <FontAwesomeIcon icon={service.icon} />
                    </span>
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li><Link to="/kontakt" onClick={handleLinkClick}>Kontakt</Link></li>
        </ul>
      </nav>
      <div className="tabletogmobil-footer">
        <a href="tel:+4522780476" className="tabletogmobil-phone">
          <span className="tabletogmobil-phone-icon">
            <FontAwesomeIcon icon={faPhone} />
          </span>
          <span>
            <small>Ring til os</small>
            22 78 04 76
          </span>
        </a>
        <Link to="/kontakt" className="tabletogmobil-cta" onClick={handleLinkClick}>
          Få et gratis tilbud
        </Link>
      </div>
    </div>
  );
}

export default TabletAndPhoneMenu;
